import api from './api';

// Sprint 8 — Dashboard agregações.
// 2026-05-23: estendido com "Top offenders" (incidents/HWIDs/IPs + sparkline 7d).
// Backend: GET /admin/dashboard/summary?window=1h|24h|7d&limit=N (baseURL axios já /api/v1).

export interface EventTypeCount {
  event_type: string;
  count: number;
}

export interface TopIncident {
  uuid: string;
  attack_category: string;
  severity_max: number;
  summary: string;
  status: string;
  hwid: string;
  source_ip: string;
  created_at: string;  // ISO 8601
}

export interface TopHwid {
  hwid: string;
  incident_count: number;       // 2026-05-24: total (qualquer categoria)
  hard_incident_count: number;  // subset PACKET_SNIFFER+MEMORY_HACK+KERNEL_TOOLING
  hard_incident_count_24h: number;
  max_severity: number;
  last_seen_at: string;
  sparkline_7d: number[];  // 7 ints, last index = today
}

export interface TopIp {
  source_ip: string;
  incident_count: number;       // total
  hard_incident_count: number;
  hard_incident_count_24h: number;
  distinct_hwids_count: number;
  max_severity: number;
  last_seen_at: string;
  sparkline_7d: number[];
}

export interface DashboardSummary {
  sessions_active: number;
  events_24h_total: number;
  events_24h_by_type: EventTypeCount[];
  kill_switches_active: number;
  ruleset: {
    present: boolean;
    version: string;
    key_id: string;
    rules_count: number;
  };
  // Top offenders extension.
  window: string;          // echo do request
  limit_top: number;
  top_incidents: TopIncident[];
  top_hwids: TopHwid[];
  top_ips: TopIp[];
}

export type DashboardWindow = '1h' | '24h' | '7d';

export interface GetSummaryParams {
  window?: DashboardWindow;
  limit?: number;
}

export async function getDashboardSummary(
  params: GetSummaryParams = {},
): Promise<DashboardSummary> {
  const { data } = await api.get<DashboardSummary>('/admin/dashboard/summary', {
    params: {
      window: params.window ?? '7d',
      limit: params.limit ?? 10,
    },
  });
  return data;
}
